module.exports = __webpack_public_path__ + "static/media/Standee-Image.4ae6b007.jpg";